/* eslint-disable no-multi-str */
import React from 'react'
import { Button } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'
import { RelatedItem } from './related-item'
import Select from 'react-select'

const FormStory = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <div>
      <div className="mb-5">
        <p className="text-lg font-bold mb-5">Story of Change</p>
        <div className="w-full flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full lg:w-2/3 mr-4 lg:mr-2" options={[]} placeholder="Search from blog" />
          <Button
            style={{maxWidth: isMobile ? '25%' : '137px'}}
            thin
            className="w-full lg:w-auto h-full px-4"
          >
            Add
          </Button>
        </div>
        <div className="flex flex-wrap">
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <RelatedItem value="Story of A"/>
          </div>
          <div className="mb-4 lg:mb-2">
            <RelatedItem value="Story of B"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export { FormStory }